// extracted by mini-css-extract-plugin
export default {"logotype":"TrainingDrawerMenu_logotype__CjJej","drawerHeader":"TrainingDrawerMenu_drawerHeader__syFbv","closeIcon":"TrainingDrawerMenu_closeIcon__VjZGe"};